
<ng-container *ngIf="settingsLoaded; else loadingSettings">
<div class="flex flex-wrap items-end justify-between gap-6 p-8 box-border w-full">
  <div>
    <h2 class="text-2xl font-bold text-gray-800 mb-1">Pregled več tarč</h2>
  </div>
  <div class="flex flex-wrap items-end gap-3 rounded-xl border border-blue-100 bg-blue-50 p-4 shadow-sm">
    <label class="flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Prikaz strelov
      <select [value]="selectedShotGroupStart" (change)="setShotGroup($any($event.target).value)" class="rounded-lg border border-blue-200 bg-white px-3 py-2 text-base font-bold text-blue-800" aria-label="Izberi skupino strelov">
        <option value="last">Zadnjih 10</option>
        <option value="all">Vsi streli</option>
        <option *ngFor="let group of shotGroups" [value]="group.start">{{ group.start }}-{{ group.end }}</option>
      </select>
    </label>
    <label class="flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Prikaz tarč
      <select [value]="targetDisplayMode" (change)="setTargetDisplayMode($any($event.target).value)" class="rounded-lg border border-blue-200 bg-white px-3 py-2 text-base font-bold text-blue-800" aria-label="Izberi prikaz tarč">
        <option value="standard">Brez menjave</option>
        <option value="rotate-pages">Avtomatska menjava tarč</option>
      </select>
    </label>
    <label class="flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Čas menjave tarč (sekunde)
      <input type="number" min="1" max="300" [value]="targetRotationSeconds" (input)="setTargetRotationSeconds($any($event.target).value)" class="w-24 rounded-lg border border-blue-200 bg-white px-3 py-2 text-base font-bold text-blue-800" aria-label="Čas menjave tarč v sekundah" />
    </label>
    <label class="flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Število vrstic
      <input type="number" min="1" max="10" [value]="gridRows" (input)="setGridRows($any($event.target).value)" class="w-24 rounded-lg border border-blue-200 bg-white px-3 py-2 text-base font-bold text-blue-800" aria-label="Število vrstic tarč" />
    </label>
    <label class="flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Tarč v vrstici
      <input type="number" min="1" max="12" [value]="targetsPerRow" (input)="setTargetsPerRow($any($event.target).value)" class="w-24 rounded-lg border border-blue-200 bg-white px-3 py-2 text-base font-bold text-blue-800" aria-label="Število tarč v vrstici" />
    </label>
    <button type="button" (click)="onSaveDisplaySettings()" class="rounded-lg bg-blue-700 px-4 py-2 text-sm font-bold text-white shadow-sm transition-colors hover:bg-blue-800" aria-label="Shrani nastavitve prikaza">
      Shrani
    </button>
    <div class="pb-2 text-sm font-semibold text-blue-800">Prikazanih tarč: {{ visibleTargets.length }}</div>
  </div>
</div>

<div class="flex flex-col items-center w-full p-5 box-border">
  <!-- Full Scores Table -->
  <div class="w-full mb-5">
    <table class="w-full border-collapse shadow-lg rounded-xl overflow-hidden">
      <thead>
        <tr class="bg-gradient-to-r from-blue-100 to-blue-300">
          <th class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Tarča</th>
          <th *ngIf="isGroupVisible('S10')" class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Serija 1</th>
          <th *ngIf="isGroupVisible('S20')" class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Serija 2</th>
          <th *ngIf="isGroupVisible('S30')" class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Serija 3</th>
          <th *ngIf="isGroupVisible('S40')" class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Serija 4</th>
          <th *ngIf="isGroupVisible('S50')" class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Serija 5</th>
          <th *ngIf="isGroupVisible('S60')" class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Serija 6</th>
          <th class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Notranji center*</th>
          <th class="border border-blue-200 p-2 text-center text-blue-800 font-bold">Skupaj</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let target of visibleTargets">
          <tr class="even:bg-blue-50 hover:bg-blue-100 transition-colors duration-150">
            <td class="border border-blue-200 p-2 text-center text-lg">
              <div class="font-semibold">Tarča {{ target.TargetOrder }}</div>
              <div class="text-sm text-gray-600">{{ shotsResultsByTarget[target.targetID]?.member_full_name || target.member_full_name || '-' }}</div>
            </td>
            <td *ngIf="isGroupVisible('S10')" class="border border-blue-200 p-2 text-center text-lg">{{ shotsResultsByTarget[target.targetID]?.S10 | number:'1.1-1' }}</td>
            <td *ngIf="isGroupVisible('S20')" class="border border-blue-200 p-2 text-center text-lg">{{ shotsResultsByTarget[target.targetID]?.S20 | number:'1.1-1' }}</td>
            <td *ngIf="isGroupVisible('S30')" class="border border-blue-200 p-2 text-center text-lg">{{ shotsResultsByTarget[target.targetID]?.S30 | number:'1.1-1' }}</td>
            <td *ngIf="isGroupVisible('S40')" class="border border-blue-200 p-2 text-center text-lg">{{ shotsResultsByTarget[target.targetID]?.S40 | number:'1.1-1' }}</td>
            <td *ngIf="isGroupVisible('S50')" class="border border-blue-200 p-2 text-center text-lg">{{ shotsResultsByTarget[target.targetID]?.S50 | number:'1.1-1' }}</td>
            <td *ngIf="isGroupVisible('S60')" class="border border-blue-200 p-2 text-center text-lg">{{ shotsResultsByTarget[target.targetID]?.S60 | number:'1.1-1' }}</td>
            <td class="border border-blue-200 p-2 text-center text-lg">{{ shotsResultsByTarget[target.targetID]?.inner_center }}</td>
            <td class="border border-blue-200 p-2 text-center text-lg font-bold text-blue-900"><strong>{{ shotsResultsByTarget[target.targetID]?.series_sum | number:'1.1-1' }}</strong></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
<!-- Target Grid -->
<div class="target-grid-shell p-4 sm:p-8 bg-blue-50 rounded-xl shadow-inner border-2 border-dashed border-blue-200 mt-4">
  <div #canvasContainer class="target-canvas-block"></div>
</div>
</ng-container>

<ng-template #loadingSettings>
  <div class="flex min-h-48 items-center justify-center p-8 text-lg font-semibold text-blue-800">
    Nalagam nastavitve prikaza ...
  </div>
</ng-template>